import { Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

function ProtectedRoute({ children }) {
  const { user } = useAuth();

  // If user is logged in or guest, allow access
  if (user || localStorage.getItem('guest') === 'true') {
    return children;
  }

  // Otherwise, redirect to login
  return <Navigate to="/login" replace />;
}

export default ProtectedRoute;
